/**
 * The platform's day boundary is America/Montréal — never the viewer's, and
 * never UTC (§6.4).
 *
 * The backend keys `challenge_entries` on `(user, day)` in Montréal time. A
 * parent logging at 21:00 is already tomorrow in UTC, so
 * `toISOString().slice(0,10)` makes two entries an hour apart look like two
 * days — and the streak that results is wrong in the direction that rewards
 * nobody.
 */
export const PLATFORM_TIMEZONE = 'America/Montreal';
/** `YYYY-MM-DD` in Montréal, matching the API's `CalendarDay`. */
export function dayIn(date = new Date(), timeZone = PLATFORM_TIMEZONE) {
    // `en-CA` formats as YYYY-MM-DD, which is exactly the contract's shape.
    return new Intl.DateTimeFormat('en-CA', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(date);
}
export function isToday(day) {
    return day === dayIn();
}
/**
 * Whether a day can still be marked done — the server's rule, mirrored so the
 * grid disables what would be refused rather than letting a member tap into a
 * 400 (8 Oct 2026).
 *
 * Today and yesterday always. With `weekStartsOn` — the start of the period
 * running today — every day of that week too, but never more than six days
 * back (a month-long period must not reopen a month). Without it, the old
 * today-and-yesterday rule, which is what a caller that predates the week
 * rule (the mobile app) still asks.
 */
export function isBackfillable(day, weekStartsOn) {
    const today = dayIn();
    if (day > today)
        return false;
    const yesterday = dayIn(new Date(Date.now() - 24 * 60 * 60 * 1000));
    if (day >= yesterday)
        return true;
    if (!weekStartsOn)
        return false;
    const sixBack = dayIn(new Date(Date.now() - 6 * 24 * 60 * 60 * 1000));
    return day >= weekStartsOn && day >= sixBack;
}
//# sourceMappingURL=dates.js.map